import _ from 'lodash';
import { getSLDImageAndAltForSinglePoint } from '../shared/SLDDynamicImages';
import { renderDoublePointImage } from '../components/SLD/Common/doublePointService';
import { sldImageBasePath } from '../shared/constants';
import { Utils } from '@orxagridrepo/sld-ui';

export const parseFileContent = (content) => {
  if (_.isString(content)) return parseFileContent(JSON.parse(content));
  return content;
};

export const createDatValuesResponseObject = (res) => {
  const { pdsData, adsData, dcData, pdsDataCols, adsDataCols, dcDataCols } =
    res.data.result;

  const apiResultPDSData = Utils.replaceKeysWithAliasName(
    pdsDataCols,
    pdsData,
    'pds'
  );
  const apiResultADSData = Utils.replaceKeysWithAliasName(
    adsDataCols,
    adsData,
    'ads'
  );
  const apiResultDCData = Utils.replaceKeysWithAliasName(
    dcDataCols,
    dcData,
    'dc'
  );

  return { apiResultPDSData, apiResultADSData, apiResultDCData };
};

export const isDIAssociatedClass = (assetClass) => {
  return assetClass === 'isolator' ||
    assetClass === 'breaker' ||
    assetClass === 'relay'
    ? true
    : false;
};

export const replaceSLDFileWithNewValues = async (
  sldObject,
  diDataResponse
) => {
  let apiResultDIData = [];

  const assets = sldObject;
  if (diDataResponse?.diData) {
    apiResultDIData = diDataResponse?.diData;
  }
  const assetIds = _.uniq(apiResultDIData.map((x) => x.AssetId?.toString()));
  let filteredAssets = assets.filter(
    (asset) =>
      asset.assetId &&
      isDIAssociatedClass(asset.className) &&
      assetIds.includes(asset.assetId?.toString())
  ); /*asset.className === 'isolator'*/
  const newData = _.map(filteredAssets, async (asset) => {
    const matchedAssetDI = apiResultDIData.filter(
      (assetDI) =>
        assetDI['AssetId'] !== undefined &&
        assetDI['AssetId']?.toString() === asset.assetId?.toString() &&
        assetDI['Asset2DiSettingId']?.toString() ===
          asset.assetDISettingId?.toString()
    );

    if (matchedAssetDI.length > 0) {
      asset['diData'] = matchedAssetDI[0];

      let DICurrentStatus = asset.diData.DICurrentStatus;
      if (
        Object.prototype.hasOwnProperty.call(asset, 'DoublePoint') &&
        asset['DoublePoint'] === true
      ) {
        const { alt, src } = renderDoublePointImage(
          asset.className,
          DICurrentStatus,
          asset.orientation
        );
        if (alt && src) {
          asset.img_src = `${sldImageBasePath}${src}`;
          asset.altTxt = alt;
        }
        return asset;
      }

      asset.img_src_orig = asset.img_src;
      asset.altTxt_orig = asset.altTxt;

      // Important comment : For Breaker default color : 0 = green  1 = red
      if (
        Object.prototype.hasOwnProperty.call(asset, 'zerosColor') &&
        Object.prototype.hasOwnProperty.call(asset, 'onesColor') &&
        (asset.zerosColor === 'red' || asset.onesColor === 'green')
      ) {
        DICurrentStatus = DICurrentStatus?.toString() === '1' ? 0 : 1; // invert 0/1 for color display
      }

      const { img, alt } = await getSLDImageAndAltForSinglePoint(
        asset.className,
        DICurrentStatus,
        asset.orientation,
        asset.category,
        asset?.altTxt_orig,
        asset?.img_src_orig
      );
      asset.img_src = img;
      asset.altTxt = alt;
    }
    return asset;
  });

  // replace in original object
  const finalObject = sldObject.map((asset) => {
    const selected = newData.find((item) => item.txId === asset.txId);
    if (selected) {
      return { ...asset, ...selected };
    }
    return asset;
  });

  return finalObject;
};

export const replaceDataValuesInSLD = async (
  sldObject = [],
  apiResultPDSData = [],
  apiResultADSData = [],
  apiResultDCData = [],
  genericValues = null
) => {
  const filteredAssets = sldObject.filter((asset) => asset.assetId);

  // eslint-disable-next-line array-callback-return
  const modifiedObject = _.map(filteredAssets, (asset) => {
    if (asset.className !== 'isolator') {
      const matchedAssetPDS = apiResultPDSData?.filter(
        (assetPDS) =>
          assetPDS.AssetId !== undefined &&
          assetPDS.AssetId?.toString() === asset.assetId?.toString()
      );
      if (matchedAssetPDS.length > 0) {
        asset.data = matchedAssetPDS[0];
      }

      const matchedAssetADS = apiResultADSData.filter(
        (assetADS) =>
          assetADS.AssetId !== undefined &&
          assetADS.AssetId?.toString() === asset.assetId?.toString()
      );
      if (matchedAssetADS.length > 0) {
        asset.data = {
          ...matchedAssetPDS[0],
          ...matchedAssetADS[0],
        };
      }
      const matchedAssetDC = apiResultDCData.filter(
        (assetDC) =>
          assetDC.AssetId !== undefined &&
          assetDC.AssetId?.toString() === asset.assetId?.toString()
      );
      if (matchedAssetDC.length > 0 && asset.className === 'breaker') {
        if (!Object.prototype.hasOwnProperty.call(asset, 'data')) {
          asset.data = {};
        }
        const keyList = Object.keys(matchedAssetDC[0]);
        for (let i = 0; i < keyList.length; ++i) {
          // eslint-disable-next-line no-prototype-builtins
          if (matchedAssetDC[0].hasOwnProperty(keyList[i])) {
            asset.data[keyList[i]] = matchedAssetDC[0][keyList[i]];
          }
        }
      }

      if (genericValues?.gdsData.length) {
        const matchedAssetGDSDataFromAPI = _.find(
          genericValues?.gdsData,
          (assetGDS) =>
            assetGDS?.AssetId.toString() === asset?.assetId.toString()
        );
        const matchedAssetGDSDataCols = _.find(
          genericValues?.gdsDataCols,
          (col) => col?._AssetId.toString() === asset?.assetId.toString()
        ); // find for particular asset data to show fileds

        let strMatchedAssetGDSDataFromAPI;
        if (matchedAssetGDSDataCols && matchedAssetGDSDataFromAPI) {
          strMatchedAssetGDSDataFromAPI = JSON.stringify(
            matchedAssetGDSDataFromAPI
          );
          const GDSDataColsKeys = _.keys(
            _.omitBy(matchedAssetGDSDataCols, _.isNil)
          );
          GDSDataColsKeys.forEach((columnKey) => {
            strMatchedAssetGDSDataFromAPI = strMatchedAssetGDSDataFromAPI
              .split('"' + columnKey + '"')
              .join('"' + matchedAssetGDSDataCols[columnKey] + '"');
          });
        }
        const matchedGeneratedGDSData = strMatchedAssetGDSDataFromAPI
          ? _.omitBy(JSON.parse(strMatchedAssetGDSDataFromAPI), _.isNil)
          : null;
        if (matchedGeneratedGDSData) {
          asset['data'] = {
            ...matchedAssetPDS[0],
            ...matchedAssetADS[0],
            ...matchedGeneratedGDSData,
          };
        }
      }

      const matchUnassigned = sldObject?.filter(
        (assetsU) => assetsU.assetId !== undefined && assetsU.assetId === '0'
      );
      if (matchUnassigned.length > 0 && matchUnassigned.txId === asset.txId) {
        asset.data = undefined;
      }
    }
    return asset;
  });

  //merge object into original SLD
  const finalObject = sldObject.map((asset) => {
    const selected = modifiedObject.find((item) => item.txId === asset.txId);
    if (selected) {
      return { ...asset, ...selected };
    }
    return asset;
  });
  return await finalObject;
};
